import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExceptionListIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={14}
    fill="none"
    viewBox="0 0 16 14"
    {...props}
  >
    <path
      fill="#111"
      d="M8.459 3.582c0-.408.158-.738.352-.738h6.813c.194 0 .352.33.352.738 0 .407-.158.738-.353.738H8.811c-.194 0-.352-.33-.352-.738M.941 8.423c0-.402.316-.728.706-.728h13.647c.39 0 .706.326.706.728a.717.717 0 0 1-.706.728H1.647a.717.717 0 0 1-.706-.728M1.647 12.547a.717.717 0 0 0-.706.727c0 .402.316.728.706.728h13.647c.39 0 .706-.326.706-.728a.717.717 0 0 0-.706-.727z"
    />
    <path
      fill="#DD1818"
      d="m1.35 1.457.051-.06a.53.53 0 0 1 .69-.051l.059.051 2.096 2.096 2.096-2.096a.53.53 0 1 1 .749.749L4.995 4.242l2.096 2.096a.53.53 0 0 1 .051.69l-.051.06a.53.53 0 0 1-.69.05l-.059-.05L4.246 4.99 2.15 7.087a.53.53 0 0 1-.749-.749l2.096-2.096-2.096-2.096a.53.53 0 0 1-.051-.69"
    />
  </svg>
);
export default SvgExceptionListIcon;
